module.exports = __webpack_public_path__ + "static/media/SDG14.7432e1e0.mp4";